"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MessageListMessageModern = _interopRequireDefault(require("./MessageListMessageModern"));
var _MessageListMessageCompact = _interopRequireDefault(require("./MessageListMessageCompact"));
var _MessageListMessageInline = _interopRequireDefault(require("./MessageListMessageInline"));
var _MessageAggregation = require("@/libs/MessageAggregation");
// Renders an aggregated traffic group. Collapsed, it is a concise summary built from the
// data the events carry (arrival nicks + per-type counts) plus a single timestamp (the
// group's first event). An isolated single event, or the expanded view, delegates to the
// normal per-message component so each line is formatted exactly like an ungrouped one.
var _default = exports.default = {
  components: {
    MessageListMessageModern: _MessageListMessageModern.default,
    MessageListMessageCompact: _MessageListMessageCompact.default,
    MessageListMessageInline: _MessageListMessageInline.default
  },
  props: ['group', 'buffer', 'ml'],
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    summary() {
      return (0, _MessageAggregation.summarizeTrafficGroup)(this.group);
    },
    firstTime() {
      return this.group.events[0].time;
    },
    messageComponent() {
      switch (this.ml.listType) {
        case 'compact':
          return 'MessageListMessageCompact';
        case 'inline':
          return 'MessageListMessageInline';
        default:
          return 'MessageListMessageModern';
      }
    },
    // "compact" presentation lists every nick inline (IRCCloud-style), including each rename
    // as "old → new"; "résumé" (the default) names the first arrival and counts the rest.
    // mode changes stay counted in both (native messages carry no structured mode target).
    isCompact() {
      return this.buffer.setting('traffic_presentation') === 'compact';
    },
    joinsNicks() {
      if (this.isCompact) {
        return this.summary.joins.map(e => e.nick);
      }
      return this.summary.joins.length ? [this.summary.joins[0].nick] : [];
    },
    departureNicks() {
      // For a kick the departing user is `kicked`; `nick` is the kicker (see IrcClient).
      // part/quit carry the departing user in `nick`, so fall back to it.
      return this.isCompact ? this.summary.departures.map(e => e.kicked || e.nick) : [];
    },
    joinsText() {
      let n = this.summary.joins.length;
      // compact lists every nick (verb agrees with the count); résumé names the
      // first arrival then counts the rest ("…and N others joined").
      if (this.isCompact || n <= 1) {
        return this.plural('traffic_joined', this.isCompact ? n : 1);
      }
      return this.plural('traffic_joined_others', n - 1);
    },
    departuresText() {
      let n = this.summary.departures.length;
      // compact lists the nicks then the bare verb; résumé prefixes the count.
      return this.isCompact ? this.plural('traffic_left', n) : this.plural('traffic_left_count', n);
    },
    nicksText() {
      return this.plural('traffic_nick_changed', this.summary.nicks.length);
    },
    // compact lists each rename inline ("old → new"); résumé keeps the count. Empty unless we
    // have structured old + new for every event (non-compact, or older messages from before
    // IrcClient stored them) → the template then falls back to nicksText.
    nickPairs() {
      if (!this.isCompact) {
        return [];
      }
      let evs = this.summary.nicks;
      if (!evs.length || evs.some(e => !e.nick || !e.new_nick)) {
        return [];
      }
      return evs.map(e => ({
        from: e.nick,
        to: e.new_nick
      }));
    },
    modesText() {
      return this.plural('traffic_mode_changed', this.summary.modes.length);
    },
    // Maps each listed nick to its inline style, built once per render. Résumé keeps nicks
    // plain (they inherit the muted line colour → empty map); Compact colours each for
    // recognition. Resolving the map here, rather than per-nick in the template, avoids a
    // $state.getUser lookup on every render for every nick when a high-churn group lists
    // many inline. To colour nicks in every mode again, drop the isCompact guard (reversible).
    nickStyles() {
      if (!this.isCompact) {
        return {};
      }
      let styles = {};
      [...this.joinsNicks, ...this.departureNicks].forEach(nick => {
        let user = this.$state.getUser(this.buffer.networkid, nick);
        styles[nick] = {
          color: user ? this.ml.userColour(user) : ''
        };
      });
      // a rename is one identity: colour both old and new names with the renamed-to user's
      // colour (the old nick no longer resolves to a user after changeUserNick)
      this.nickPairs.forEach(pr => {
        let user = this.$state.getUser(this.buffer.networkid, pr.to);
        let colour = user ? this.ml.userColour(user) : '';
        styles[pr.from] = {
          color: colour
        };
        styles[pr.to] = {
          color: colour
        };
      });
      return styles;
    }
  },
  methods: {
    // i18next v25 resolves fr/en plurals via the _other suffix, but our keys follow the app's
    // _plural convention; pick the form here (n > 1 = plural for fr/en, the only locales) so it
    // works regardless of i18next's plural rules. count is passed through for interpolation.
    plural(base, count, opts) {
      return this.$t(count > 1 ? `${base}_plural` : base, {
        count,
        ...opts
      });
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageTrafficGroup"]
window._kiwi_exports.components.MessageListMessageTrafficGroup = exports.default ? exports.default : exports;
